import React, { createContext, useState, useContext, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const validLanguages = ["en", "ja", "zh", "vn", "ko"];
  const storedLanguage = localStorage.getItem("language");
  const initialLanguage = validLanguages.includes(storedLanguage)
    ? storedLanguage
    : "en";

  const [language, setLanguage] = useState(initialLanguage);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
